import React, { useEffect, useRef, useState } from "react";
import style from "../../../scss/Buscar.module.scss";
import { Icon } from "@iconify/react";

const ESPERA_AL_ESCRIBIR_MS = 400;

// Búsqueda por cédula o nombre (coincidencia parcial). Busca sola al dejar
// de escribir; con Enter (o el botón en móvil) busca de inmediato.
// onBuscar(texto) recibe "" cuando se limpia el campo.
const BuscarComponent = (props) => {
  const { onBuscar } = props;
  const [texto, setTexto] = useState("");
  const temporizador = useRef(null);

  const buscarAhora = (valor) => {
    clearTimeout(temporizador.current);
    onBuscar?.(valor.trim());
  };

  const handleChange = (event) => {
    const valor = event.target.value;
    setTexto(valor);
    clearTimeout(temporizador.current);
    temporizador.current = setTimeout(() => onBuscar?.(valor.trim()), ESPERA_AL_ESCRIBIR_MS);
  };

  // Enter se maneja aquí porque en desktop el botón de enviar está oculto
  // (con display:none algunos navegadores no envían el formulario con Enter)
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      buscarAhora(texto);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    buscarAhora(texto);
  };

  const limpiarBusqueda = () => {
    setTexto("");
    buscarAhora("");
  };

  useEffect(() => () => clearTimeout(temporizador.current), []);

  return (
    <form onSubmit={handleSubmit} className={style.buscador} role="search">
      <div className={style.campo}>
        <Icon icon="mdi:magnify" className={style.icono} aria-hidden="true" />
        <input
          className={style.input}
          type="text"
          placeholder="Buscar por cédula o nombre..."
          aria-label="Buscar elector por cédula o nombre"
          value={texto}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />

        {texto && (
          <button type="button" className={style.limpiar} onClick={limpiarBusqueda} aria-label="Limpiar búsqueda">
            <Icon icon="mdi:close-circle" />
          </button>
        )}

        {/* desktop: se busca con Enter */}
        <kbd className={style.atajo} aria-hidden="true">
          Enter ↵
        </kbd>

        {/* móvil: botón dentro del buscador */}
        <button type="submit" className={style.botonMovil} disabled={!texto} aria-label="Buscar">
          <Icon icon="mdi:arrow-right" />
        </button>
      </div>
    </form>
  );
};
export default BuscarComponent;
